import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { ExternalCalendarNewSection } from "./ExternalCalendarNewSection";

const ExternalCalendarNew = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalCalendarNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ExternalCalendarNewSection
        peekICalendarUrl={viewModel.peekICalendar}
        peekGoogleCalendarUrl={viewModel.peekGoogleCalendar}
        connectToGoogleUrl={viewModel.googleConnectAbsolute}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{
          href: viewModel.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default ExternalCalendarNew;